/* eslint-disable jsx-a11y/no-static-element-interactions */
import { UploadFileEntityResponse } from '@/graphql/generated/graphql';
import { ReactNode } from 'react';
import { classNames } from '@/utils/class-names';
import DefaultContentTemplateTags from '@/components/DefaultContentTemplate/Tags';
import { useResponsiveImage } from '@/utils/useResponsiveImage';

type PodcastCardProps = {
  title: string;
  description: string;
  isLocked?: boolean;
  slug?: string;
  thumbnail?: UploadFileEntityResponse;
  url: string;
  done?: boolean;
  watchLabel?: string;
  progress?: number;
  button?: ReactNode;
  tag?: string;
  duration?: string;
  onClick?: () => void;
};

const PodcastCard = ({ title, description, thumbnail, progress, button, tag, duration, onClick }: PodcastCardProps) => {
  const { src } = useResponsiveImage(thumbnail);

  const renderProgressBar = () => {
    return progress && progress > 0 ? (
      <div className="h-[6px] w-full rounded-full bg-[#2073D333]/20">
        <div
          className="h-[6px] rounded-full bg-[#488FE3]"
          style={{ width: `${progress <= 100 ? progress : 100}%` }}></div>
      </div>
    ) : (
      <></>
    );
  };

  const renderTagsAndDuration = () => {
    return (
      tag &&
      duration && (
        <DefaultContentTemplateTags duration={duration || ''} tags={[tag || '']} className="!mb-sh-15 !mt-0" />
      )
    );
  };

  const renderImage = () => {
    return (
      <div
        className={classNames('aspect-video w-full bg-cover bg-center', onClick ? 'cursor-pointer' : '')}
        onClick={onClick}
        style={{ backgroundImage: `url('${src}')` }}
      />
    );
  };
  // md:grid-cols-[218px_1fr]
  // md:h-[212px]
  return (
    <div
      className={classNames(
        'border-1 grid h-full grid-cols-1 overflow-hidden rounded-2xl border border-primary-500 bg-white md:grid-rows-[1fr_minmax(200px,_auto)]',
      )}>
      {renderImage()}
      <div className="grid rounded-b-lg px-5 py-5 md:rounded-b-none md:rounded-r-lg">
        <div className=" flex flex-col gap-sh-15 ">
          {renderTagsAndDuration()}
          <div className="flex h-full flex-col justify-between">
            <h2 className="font-larken text-sh-22-28">{title}</h2>
            <p className="line-clamp-3 text-sh-xxs text-black md:line-clamp-none" title={description}>
              {description}
            </p>
            {renderProgressBar()}
            <div className="mt-sh-10">{button}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PodcastCard;
